import { alovaInstance, type AlovaMeta, type ResponseType, withMeta } from "@@/alova";
import { PostMallV1TagListOptions } from "./postMallV1TagListApi";

export type Params = {
  pageNum: number,
  pageSize: number,
  keyword: string
}

export type detailParams = {
  mobileFingerprint: string,
  commodityId: string,
  mobileSessionid: string,
  t:number
}

export type  TinyurlCreateParams = {
  effectiveTimeSecond:number,
  originUrl: string
}

/**
 * @description 查询good列表
 * @param {number} params 参数
 * @return {object}
 */
export const getGoodList = (
  data: Params,
  options?: {
    params?: object;
    headers?: object;
    meta?: AlovaMeta;
  }
) => {
  return withMeta(
    alovaInstance.Post<ResponseType, Params>(
      `mall/v1/commodity/list`,
      data,
      {
        ...(options?.params ?? {}),
        headers: {
          ...(options?.headers ?? {})
        }
      }
    ),
    options?.meta
  );
};

/**
 * @description 获取商品详情
 * @param {number} params 参数
 * @return {object}
 */
export const getGoodDetails = (
  data: detailParams,
  options?: {
    params?: object;
    headers?: object;
    meta?: AlovaMeta;
  }
) => {
  let baseParams
  if(window){
    baseParams = JSON.parse(sessionStorage.getItem("baseParams"));
  }
  return alovaInstance.Post<ResponseType, detailParams>(
      `mall/v1/commodity/detail`,
      data,
      {
        ...(options?.params ?? {}),
        headers: {
          ...(options?.headers ?? {}),
          selfPackageName: baseParams?.selfPackageName
        },
        ...options?.meta
      }
    )
};

/**
 * @description 获取基础信息
 * @param {params} params 参数
 * @return {object}
 */
export const tinyurlCreate = (
  data: TinyurlCreateParams,
  options?: {
    params?: object;
    headers?: object;
    meta?: AlovaMeta;
  }
) => {
  return withMeta(
    alovaInstance.Post<ResponseType, Params>(
      `/tinyurl/create`,
      data,
      {
        ...(options?.params ?? {}),
        headers: {
          ...(options?.headers ?? {})
        }
      }
    ),
    options?.meta
  );
};

/**
 * 获取页面中枢
 * @param {Array} codeList 中枢id列表
 * @returns {*} 返回
 */
export const getPageCenter = (
  data,
  options?: {
    params?: object;
    headers?: object;
    meta?: AlovaMeta;
  }
) => {
  const baseParams = JSON.parse(sessionStorage.getItem("baseParams"));
  return withMeta(
    alovaInstance.Post<ResponseType, Params>(
      `protocol/v1/query/batch`,
      data,
      {
        ...(options?.params ?? {}),
        headers: {
          ...(options?.headers ?? {}),
          selfPackageName: baseParams.selfPackageName
        }
      }
    ),
    options?.meta
  );
};

/**
 * 兑换页面绑定手机号
 * @param {Object} params 参数
 * @returns {*} 返回
 */
export const surephone = (
  data,
  options?: {
    params?: object;
    headers?: object;
    meta?: AlovaMeta;
  }
) => {
  const baseParams = JSON.parse(sessionStorage.getItem("baseParams"));
  return withMeta(
    alovaInstance.Post<ResponseType, Params>(
      `/mall/v1/mobile/integral/auth/page/query`,
      {
        ...data,
        mobileFingerprint : sessionStorage.getItem("blackbox"),
        mobileSessionid: sessionStorage.getItem("sessionId"),
        commodityId :sessionStorage.getItem("commodityId")
      },
      {
        ...(options?.params ?? {}),
        headers: {
          ...(options?.headers ?? {}),
          selfPackageName: baseParams.selfPackageName
        }
      }
    ),
    options?.meta
  );
};


/**
 * 兑换商品订单创建
 * @param {Object} params 参数
 * @returns {*} 返回
 */
export const exchangeGoods = (
  data,
  options?: {
    params?: object;
    headers?: object;
    meta?: AlovaMeta;
  }
) => {
  const baseParams = JSON.parse(sessionStorage.getItem("baseParams"));
  return withMeta(
    alovaInstance.Post<ResponseType, Params>(
      `/mall/v1/order/create`,
      {
        ...data,
        mobileFingerprint : sessionStorage.getItem("blackbox"),
        mobileSessionid: sessionStorage.getItem("sessionId"),
        commodityId :sessionStorage.getItem("commodityId")
      },
      {
        ...(options?.params ?? {}),
        headers: {
          ...(options?.headers ?? {}),
          selfPackageName: baseParams.selfPackageName
        }
      }
    ),
    options?.meta
  );
};

/**
 * 验证码获取奖品
 * @param {Object} params 参数
 * @returns {*} 返回
 */
export const surecode = (
  data,
  options?: {
    params?: object;
    headers?: object;
    meta?: AlovaMeta;
  }
) => {
  const baseParams = JSON.parse(sessionStorage.getItem("baseParams"));
  return withMeta(
    alovaInstance.Post<ResponseType, Params>(
      `/mall/v1/order/pay`,
      {
        ...data,
        mobileFingerprint : sessionStorage.getItem("blackbox"),
        mobileSessionid: sessionStorage.getItem("sessionId"),
      },
      {
        ...(options?.params ?? {}),
        headers: {
          ...(options?.headers ?? {}),
          selfPackageName: baseParams.selfPackageName
        }
      }
    ),
    options?.meta
  );
};

/**
 * 判断是否是会员
 * @returns {*} 返回
 */
export const sureMember = (
  options?: {
    params?: object;
    headers?: object;
    meta?: AlovaMeta;
  }
) => {
  return withMeta(
    alovaInstance.Post<ResponseType, Params>(
      `/member/v2/member/infos`,
      {
        types: [3]
      },
      {
        ...(options?.params ?? {}),
        headers: {
          ...(options?.headers ?? {})
        }
      }
    ),
    options?.meta
  );
};

/**
 * @description 请求乐币数量
 * @returns {*} 返回
 */
export const getLecionBalance = (
  options?: {
    params?: object;
    headers?: object;
    meta?: AlovaMeta;
  }
) => {
  return withMeta(
    alovaInstance.Post<ResponseType, Params>(
      `/lecoin/v1/lecoin/user/balance`,
      {
        types: [3]
      },
      {
        ...(options?.params ?? {}),
        headers: {
          ...(options?.headers ?? {})
        }
      }
    ),
    options?.meta
  );
};

/**
 * @description 获取兑换列表
 * @returns {*} 返回
 */
export const getOrderList = (
  pageNum:number,
  options?: {
    params?: object;
    headers?: object;
    meta?: AlovaMeta;
  }
) => {
  return withMeta(
    alovaInstance.Post<ResponseType, Params>(
      `/mall/v1/order/list`,
      {
        pageNum,
        pageSize: 20
      },
      {
        ...(options?.params ?? {}),
        headers: {
          ...(options?.headers ?? {})
        }
      }
    ),
    options?.meta
  );
};


/**
 * 商城主页合并列表
 * @returns {*} 返回
 */
export const getListMerge = (
  data: any,
  options?: {
    params?: object;
    headers?: object;
    meta?: AlovaMeta;
  }
) =>  {
  return alovaInstance.Post<ResponseType, Params>(
    `/mall/v1/list/merge`,
    data,
    {
      ...(options?.params ?? {}),
      headers: {
        ...(options?.headers ?? {})
      },
      ...options?.meta
    }
  )
}